import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-import",
  "use": "icon-import-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 14 14\" id=\"icon-import\">\r\n<polyline class=\"st0\" points=\"12.3,4.4 7,9.6 1.8,4.4 \" />\r\n<rect x=\"0.6\" y=\"11.8\" class=\"st1\" width=\"12.8\" height=\"2.1\" />\r\n<rect x=\"6.1\" y=\"0.1\" class=\"st1\" width=\"1.9\" height=\"9.6\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol